import { Suspense, lazy } from 'react';
import type { RouteObject } from 'react-router';
import WalletLayout from './components/walletLayout/WalletLayout';
import TotalSupplyPage from './features/totalSupply/totalSupplyPage';
import UpdateHolderPage from './features/updateHolder/updateHolderPage';
import ViewDataPage from './features/viewData/viewDataPage';
import CheckBalancePage from './features/checkBalance/checkBalancePage';
import PermissionPage from './features/permission/permissionPage';
import UploadFilePage from './features/uploadFile/uploadFilePage';
import StatusPage from './features/status/statusPage';
import ChangeContractOwnerPage from './features/changeContractOwner/changeContractOwnerPage';

const Loadable = (Component: any) => (props: JSX.IntrinsicAttributes) =>
(
    <Suspense>
        <Component {...props} />
    </Suspense >
);

// *  AUTHENTICATION PAGES


//  * PAGE
const ControllerPage = Loadable(lazy(() => import('./features/controller/controllerPage')));
const IssuerPage = Loadable(lazy(() => import('./features/issuer/issuerPage')));
const LandingPage = Loadable(lazy(() => import('./features/landing/landingPage')));
const AdminPage = Loadable(lazy(() => import('./features/adminPage/adminPage')));
const ConnectionPage = Loadable(lazy(() => import('./features/connection/connectionPage')));
const TokenActionPage = Loadable(lazy(() => import('./features/tokenAction/tokenActionPage')));
const ManageContractAddressInputPage = Loadable(lazy(() => import('./features/manageContractAddressInput/manageContractAddressInputPage')));
const ManageContractPage = Loadable(lazy(() => import('./features/manageContract/manageContractPage')));
const CreateTokenPage = Loadable(lazy(() => import('./features/createToken/createTokenPage')));
const AddExitTokenPage = Loadable(lazy(() => import('./features/addExitToken/addExitTokenPage')));
const routes: RouteObject[] = [
    {
        path: '/',
        element: <WalletLayout />,
        children: [
            {
                index: true,
                element: <LandingPage />,
            },
            {
                path: 'permission',
                element: <PermissionPage />,
            },
        ],
    },
    {
        path: '/connect-wallet',
        element: <WalletLayout />,
        children: [
            {
                index: true,
                element: <ConnectionPage />,
            },
        ],
    },
    {
        path: '/tokenAction',
        element: <WalletLayout role="tokenAction" />,
        children: [
            {
                index: true,
                element: <TokenActionPage />,
            },
            {
                path: 'manage-contract-address-input',
                element: <ManageContractAddressInputPage />,
            },
            {
                path: 'manage-contract',
                element: <ManageContractPage />,
            },
            {
                path: 'createToken',
                element: <CreateTokenPage />,
            },
            {
                path: 'add-exit-token',
                element: <AddExitTokenPage />,
            }
        ],
    },
    {
        path: '/issuer',
        element: <WalletLayout role="issuer" />,
        children: [
            {
                index: true,
                element: <IssuerPage />,
            },
            {
                path: 'total-supply',
                element: <TotalSupplyPage />,
            },
            // {
            //     path: 'update-holder',
            //     element: <UpdateHolderPage />,
            // }
        ],
    },
    {
        path: '/controller',
        element: <WalletLayout role="controller" />,
        children: [
            {
                index: true,
                element: <ControllerPage />,
            },
            {
                path: 'permission',
                element: <PermissionPage />,
            },
            {
                path: 'new-holder',
                children: [
                    {
                        path: 'upload-file',
                        element: <UploadFilePage />,
                    },
                ]
            },
            {
                path: 'update-balance',
                children: [
                    {
                        path: 'upload-file',
                        element: <UploadFilePage />,
                    },
                ]
            },
        ],
    },
    {
        path: '/admin',
        element: <WalletLayout role="admin" />,
        children: [
            {
                index: true,
                element: <AdminPage />,
            },
            {
                path: 'update-holder',
                element: <UpdateHolderPage />,
            },
            {
                path: 'change-contract-owner',
                element: <ChangeContractOwnerPage />,
            },

        ],
    },
    {
        path: '/view-data',
        element: <WalletLayout />,
        children: [
            {
                index: true,
                element: <ViewDataPage />,
            },
        ],
    },
    {
        path: '/check-balance',
        element: <WalletLayout role="view-data" />,
        children: [
            {
                index: true,
                element: <CheckBalancePage />,
            },
        ],
    },
    {
        path: '/status',
        element: <WalletLayout />,
        children: [
            {
                index: true,
                element: <StatusPage />,
            },
        ],
    },
    // Not Found
    {
        path: '*',
        children: [
            {
                index: true,
                element: <></>,
            },
        ],
    }
];

export default routes;